export default {"src":"/_next/static/media/prepay.734ef21e.svg","height":72,"width":96,"blurWidth":0,"blurHeight":0};